var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.876,
    height: 42.126,
    viewBox: "0 0 52.876 42.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38724",
    "data-name": "\\uADF8\\uB8F9 38724",
    transform: "translate(2.828 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_7",
    "data-name": "\\uD0C0\\uC6D0 7",
    cx: 5.101,
    cy: 5.101,
    r: 5.101,
    transform: "translate(18.508 28.423)",
    fill: "#f09",
    stroke: "#f09",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_80",
    "data-name": "\\uD328\\uC2A4 80",
    d: "M680.358,1143.294a33.693,33.693,0,0,0-47.22,0",
    transform: "translate(-633.138 -1133.638)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_81",
    "data-name": "\\uD328\\uC2A4 81",
    d: "M690.563,1179.51a24.081,24.081,0,0,0-35.112,0",
    transform: "translate(-649.396 -1163.527)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_82",
    "data-name": "\\uD328\\uC2A4 82",
    d: "M709.937,1216.879a18.044,18.044,0,0,0-26.838,0",
    transform: "translate(-672.908 -1193.686)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceWifi);
export default __webpack_public_path__ + "static/media/icon-service-wifi.8df2079570e1b16b5e6a6afb235b3d33.svg";
export { ForwardRef as ReactComponent };